import { DatabaseService, PromoCode, PromoCodeData, PromoCodeRepository } from "@/core";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getPromoCodeRepository(
  databaseService: DatabaseService,
): PromoCodeRepository {
  return getGenericRepository<PromoCode, PromoCodeData>(
    () => DatabaseCollection.PROMO_CODES,
    databaseService,
  );
}

